module.exports = __webpack_public_path__ + "img/Cooler.943b2fd7.svg";